import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../App.css';

function TermsOfService() {
  const navigate = useNavigate();
  const updated = 'April 20, 2025';

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <Helmet>
        <title>Terms of Service | OfferLelo</title>
        <meta name="description" content="Read OfferLelo's Terms of Service. By using our website you agree to these terms governing deals, offers, and affiliate links." />
        <link rel="canonical" href="https://www.offerlelo.com/terms" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <header className="modern-header">
        <div className="header-logo" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
          <img src="/logo.svg" alt="OfferLelo Logo" />
          <span className="header-logo-text">OfferLelo</span>
        </div>
        <div className="header-actions">
          <button className="admin-btn" onClick={() => navigate('/')}>← Home</button>
        </div>
      </header>

      <div style={{ maxWidth: 860, margin: '0 auto', padding: '48px 24px 64px' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 800, color: '#1e293b', marginBottom: 8 }}>Terms of Service</h1>
        <p style={{ color: '#94a3b8', fontSize: '0.9rem', marginBottom: 40 }}>Last updated: {updated}</p>

        <div style={{ background: '#fff', borderRadius: 16, padding: '36px 40px', boxShadow: '0 4px 24px rgba(0,0,0,0.07)', lineHeight: 1.8, color: '#334155', fontSize: '1rem' }}>

          <Section title="1. Acceptance of Terms">
            By accessing or using <strong>OfferLelo</strong> at{' '}
            <a href="https://www.offerlelo.com" style={{ color: '#6366f1' }}>www.offerlelo.com</a>, you agree to be bound by these Terms of Service.
            If you do not agree to all of these terms, please do not use our website.
          </Section>

          <Section title="2. Description of Service">
            <p>
              OfferLelo is a deal aggregation and content platform that curates offers, discounts, coupons, and buying guides from various retailers and brands across India.
              We provide this information for informational purposes only.
            </p>
          </Section>

          <Section title="3. Accuracy of Offers & Pricing">
            <p>
              All deals, prices, and offers listed on OfferLelo are sourced from third-party retailers and are subject to change without notice.
              We make every effort to keep information accurate and up to date; however, <strong>we do not guarantee the accuracy, completeness, or availability of any offer listed</strong>.
            </p>
            <p>Always verify the final price and offer details on the retailer's official website before making any purchase.</p>
          </Section>

          <Section title="4. Affiliate Disclosure">
            <p>
              OfferLelo participates in affiliate marketing programs. Some links on our website are affiliate links, meaning we may receive a commission if you make a purchase through those links — at <strong>no additional cost to you</strong>.
            </p>
            <p>
              This affiliate relationship does not influence our editorial content or the deals we feature.
            </p>
          </Section>

          <Section title="5. Advertising">
            <p>
              OfferLelo displays advertisements served by <strong>Google AdSense</strong> and other advertising networks. These ads are clearly separate from our editorial content.
              We are not responsible for the content of third-party advertisements.
            </p>
          </Section>

          <Section title="6. Intellectual Property">
            <p>
              All original content on OfferLelo — including blog articles, graphics, and editorial text — is the property of OfferLelo and is protected by applicable copyright laws.
              You may not reproduce, distribute, or use our content without prior written permission.
            </p>
            <p>Product images and brand names remain the property of their respective owners.</p>
          </Section>

          <Section title="7. User Conduct">
            <p>You agree not to:</p>
            <ul>
              <li>Use the website for any unlawful purpose</li>
              <li>Attempt to gain unauthorised access to any part of the website</li>
              <li>Scrape, crawl, or harvest data from the website without permission</li>
              <li>Transmit any harmful, offensive, or disruptive content</li>
            </ul>
          </Section>

          <Section title="8. Third-Party Links">
            <p>
              Our website contains links to third-party websites. These links are provided for your convenience and do not signify our endorsement of those sites.
              OfferLelo has no control over the content or practices of third-party websites and accepts no responsibility for them.
            </p>
          </Section>

          <Section title="9. Disclaimer of Warranties">
            <p>
              The website and its content are provided on an <strong>"as is"</strong> and <strong>"as available"</strong> basis without any warranties of any kind, either express or implied.
              OfferLelo disclaims all warranties including but not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
            </p>
          </Section>

          <Section title="10. Limitation of Liability">
            <p>
              To the fullest extent permitted by law, OfferLelo shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use the website, including any reliance on deals, prices, or information published on the site.
            </p>
          </Section>

          <Section title="11. Changes to Terms">
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to the website.
              Your continued use of the website after any changes constitutes your acceptance of the new Terms.
            </p>
          </Section>

          <Section title="12. Governing Law">
            <p>
              These Terms shall be governed by and construed in accordance with the laws of India.
              Any disputes arising from the use of this website shall be subject to the jurisdiction of the courts of India.
            </p>
          </Section>

          <Section title="13. Contact Us" last>
            <p>If you have any questions about these Terms, please contact us:</p>
            <p>
              📧 Email:{' '}
              <a href="mailto:offerleleo365@gmail.com" style={{ color: '#6366f1', fontWeight: 600 }}>
                offerleleo365@gmail.com
              </a>
            </p>
            <p>🌐 Website: <a href="https://www.offerlelo.com" style={{ color: '#6366f1' }}>www.offerlelo.com</a></p>
          </Section>
        </div>
      </div>

      <div style={{ background: '#1e1b4b', color: '#6366f1', textAlign: 'center', padding: '16px', fontSize: '0.82rem' }}>
        © {new Date().getFullYear()} OfferLelo ·{' '}
        <a href="mailto:offerleleo365@gmail.com" style={{ color: '#818cf8', textDecoration: 'none' }}>offerleleo365@gmail.com</a>
      </div>
    </div>
  );
}

function Section({ title, children, last }) {
  return (
    <div style={{ marginBottom: last ? 0 : 32 }}>
      <h2 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#1e293b', marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid #f1f5f9' }}>
        {title}
      </h2>
      {children}
    </div>
  );
}

export default TermsOfService;
